import * as React from "react"
import { cn } from "@/lib/utils"

export interface ProgressProps { value: number; className?: string }
export function Progress({ value, className }: ProgressProps) {
  const v = Math.max(0, Math.min(100, value))
  return (
    <div className={cn("h-2 w-full rounded bg-muted", className)}>
      <div className="h-2 rounded bg-primary" style={{ width: `${v}%` }} />
    </div>
  )
}
